import React from 'react';

const GlobalContext = React.createContext({});
const GlobalProvider = GlobalContext.Provider;

export { GlobalContext, GlobalProvider };
